import React from "react";
import { Link } from "react-router-dom";
import "./Style.css";

const PLATFORMS = [
  { src: "/RokuLogo.png", alt: "Roku" },
  { src: "/GooglePlayStore.png", alt: "Google Play" },
  { src: "/AppleStore.png", alt: "App Store" },
  { src: "/Samsung.png", alt: "Samsung" },
  { src: "/LG.png", alt: "LG" },
  { src: "/FireTv.png", alt: "Fire TV" },
];

const Footer = () => {
  const siteTitle = process.env.REACT_APP_SITE_TITLE;
  const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;

  const LEGAL = [
    { label: "Terms of Use", href: process.env.REACT_APP_TERMS_URL },
    { label: "Privacy Policy", href: process.env.REACT_APP_PRIVACY_POLICY_URL },
    { label: "Cookie Policy", href: process.env.REACT_APP_COOKIE_POLICY_URL },
  ];

  return (
    <footer className="ott-footer">
      <div className="ott-footer__inner">

        {/* ── Top: brand + link columns ── */}
        <div className="ott-footer__top">

          {/* Brand */}
          <div className="ott-footer__brand">
            <img
              src={`/${process.env.REACT_APP_APP_LOGO}`}
              alt={siteTitle}
              className="ott-footer__logo"
            />
            <p className="ott-footer__tagline">
              Stream movies, series &amp; live TV — anytime, on any screen.
            </p>
          </div>

          {/* Help */}
          <div className="ott-footer__col">
            <h4 className="ott-footer__heading">Help</h4>
            <Link className="ott-footer__link" to={process.env.REACT_APP_CONTACT_URL}>
              Contact Support
            </Link>
          </div>

          {/* Legal */}
          <div className="ott-footer__col">
            <h4 className="ott-footer__heading">Legal</h4>
            {LEGAL.map((l) => (
              <Link
                key={l.label}
                className="ott-footer__link"
                to={l.href}
              >
                {l.label}
              </Link>
            ))}
          </div>

          {/* Platforms */}
          <div className="ott-footer__col ott-footer__col--platforms">
            <h4 className="ott-footer__heading">Available on</h4>
            <div className="ott-footer__platforms">
              {PLATFORMS.map((p) => (
                <span className="ott-footer__platform" key={p.alt} title={p.alt}>
                  <img src={p.src} alt={p.alt} loading="lazy" />
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* ── Contact + Bottom bar ── */}
        <div className="footer-contact">
          Contact Us -{" "}
          <a className="ott-footer__link" href={`mailto:${contactEmail}`}>
            {contactEmail}
          </a>
        </div>

        <div className="ott-footer__bottom">
          <span className="ott-footer__copy">
            © {new Date().getFullYear()} {siteTitle}. All rights reserved.
          </span>
          <span className="ott-footer__made">Crafted for cinematic streaming.</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;